import { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import config from '../../../config';
import { isValidGSTIN } from '../../../common/validators';
import Select from 'react-select';

function BasicInfoForm({ form, setForm, stepSubmitted }) {
    const [industryTypes, setIndustryTypes] = useState([]);

    useEffect(() => {
        const fetchIndustryTypes = async () => {
            try {
                const res = await axios.get(`${config.API_BASE_URL}/industry_type`);
                setIndustryTypes(res.data || []);
            } catch (err) {
                console.error('Failed to fetch industry types:', err);
            }
        };
        fetchIndustryTypes();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const industryTypeOptions = industryTypes.map((type) => ({
        value: type._id,
        label: type.name,
    }));

    const firmTypeOptions = [
        { value: 'Propritor', label: 'Propritor' },
        { value: 'PVT Ltd', label: 'PVT Ltd' },
        { value: 'Ltd', label: 'Ltd' },
        { value: 'Partnership', label: 'Partnership' },
    ];

    const gstRegistrationOptions = [
        { value: 'registered', label: 'GST Registered' },
        { value: 'URD', label: 'URD (Unregistered Dealer)' },
    ];

    const handleSelectChange = (selectedOption, { name }) => {
        setForm((prev) => ({
            ...prev,
            [name]: selectedOption?.value || '',
        }));
    };

    return (
        <div className="mb-4">
            <Row>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>
                            Business Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            name="business_name"
                            value={form.business_name}
                            onChange={handleChange}
                            isInvalid={stepSubmitted && !form.business_name}
                        />
                        <Form.Control.Feedback type="invalid">
                            Business name is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Alias</Form.Label>
                        <Form.Control
                            name="alias"
                            value={form.alias}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>
                            Industry Type <span className="text-danger">*</span>
                        </Form.Label>

                        <Select
                            name="industry_type"
                            value={industryTypeOptions.find(opt => opt.value === form.industry_type)}
                            onChange={handleSelectChange}
                            options={industryTypeOptions}
                            placeholder="-- Select Industry Type --"
                            classNamePrefix="react-select"
                            className={
                                stepSubmitted && !form.industry_type ? 'is-invalid  fs-9' : 'fs-9'
                            }
                        />

                        {stepSubmitted && !form.industry_type && (
                            <div className="invalid-feedback d-block">
                                Industry Type is required.
                            </div>
                        )}
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2">
                        <Form.Label>Firm Type  <span className="text-danger">*</span></Form.Label>
                        <Select
                            name="firm_type"
                            value={firmTypeOptions.find(opt => opt.value === form.firm_type)}
                            onChange={handleSelectChange}
                            options={firmTypeOptions}
                            placeholder="-- Select Firm Type --"
                            classNamePrefix="react-select"
                            className={stepSubmitted && !form.firm_type ? 'is-invalid  fs-9' : 'fs-9'}
                        />
                        {stepSubmitted && !form.firm_type && (
                            <div className="invalid-feedback d-block">
                                Firm Type is required.
                            </div>
                        )}
                    </Form.Group>
                </Col>

                <Col md={6} xl={4}>
                    <Form.Group className="mb-2 fs-9">
                        <Form.Label>GST Registration Type</Form.Label>
                        <Select
                            name="gst_registration"
                            value={gstRegistrationOptions.find(opt => opt.value === form.gst_registration)}
                            onChange={handleSelectChange}
                            options={gstRegistrationOptions}
                            placeholder="-- Select GST Type --"
                        />
                    </Form.Group>
                </Col>

                {form.gst_registration === 'registered' && (
                    <Col md={6} xl={4}>
                        <Form.Group className="mb-2">
                            <Form.Label>GSTIN</Form.Label>
                            <Form.Control
                                name="gstin"
                                value={form.gstin}
                                onChange={handleChange}
                                isInvalid={form.gstin && !isValidGSTIN(form.gstin)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Invalid GSTIN format.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                )}

            </Row>
        </div>
    );
}

BasicInfoForm.validate = function (form) {
     return (
    !!form.business_name &&
    !!form.industry_type &&
    !!form.firm_type
  );
};

export default BasicInfoForm;
